/*
创建者 李伟(2018.5.4)
*/
<template>
  <div  class="d-layout-area" id="wlDiv">
    <div class="d-layout" id="20080997">
      <div class="d-layout-one d-w990 ">
        <div class="  roulette-174865 " moduleclass="roulette-174865"
             instanceid="20081007" style="margin-bottom: 10px;"
             module-name="Lottery" data-has-point="true">

          <div class="mc" style="min-height: 0px;">
            <div class="j-module roulette-container"
                 module-function="roulette"
                 module-param="{lotterycode:'4c908011-b768-4377-b661-c1adf3aca7ab'}">

              <div class="winner-area">
                <div class="winner-title">
                  <div class="title-bg"></div>
                  <div class="title-content">获奖名单</div>
                </div>
                <div class="winner-title2 ">
                  <span class="w-th">中奖者名单</span><span class="w-th">奖品信息</span>
                </div>
                <div class="winner-list">
                  <div class="list-wrap j-list-wrap" style="display: block;">

                  </div>
                </div>
                <div class="j-no-winner no-winner hidden">
                  还没出现中奖者，期待您赢取大奖！</div>
              </div>

              <div class="bg-wrap">
                <div class="bg-widget bg-1"></div>
                <div class="bg-widget j-bg-widget bg-2"
                     style="transform: translate3d(0px, 0px, 0px);"></div>
                <div class="bg-widget j-bg-widget bg-3"
                     style="transform: translate3d(0px, 0px, 0px);"></div>
                <div class="bg-widget j-bg-widget bg-4"
                     style="transform: translate3d(0px, 0px, 0px);"></div>
              </div>

              <div class="roulette-ie hidden">
                <div class="pan-bg"></div>
                <div class="j-pan-ie pan-content"></div>
                <div class="pan-mask"></div>
                <div class="go j-run"></div>
              </div>

              <div class="roulette-chrome">
                <div class="pan-bg">
                  <div class="pan-content csstransforms">
                    <ul class="cn-wrapper j-pan-chrome item-wrap7 bg3">
                      <li class="j-prizeId-1" style="transform: rotate(64.28571428571428deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t4060/285/511182119/4588/cd0f5be7/58516953Ndb89e6c3.png"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-2" style="transform: rotate(12.857142857142847deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t3112/168/3321294261/25979/43989d54/57ee4fa9Nae3875f3.jpg"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-3" style="transform: rotate(-38.571428571428584deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t3193/161/4666645058/17002/3f68df5d/58516a93N109e1801.png"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-4" style="transform: rotate(-90deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t3124/326/4643276816/12253/b8b773c2/58516b3eN1b32169d.png"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-5"  style="transform: rotate(-141.42857142857144deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t3589/193/2349863651/2962/e87a115f/58516d1eNaa3f99c8.png"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-6" style="transform: rotate(-192.8571428571429deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                          <!-- <img src="http://img30.360buyimg.com/activity/jfs/t3826/97/2248819577/2848/c70e402f/58516d54N4b1bafa7.png"> -->
                        </div>
                      </li>

                      <li class="j-prizeId-7" style="transform: rotate(-244.28571428571428deg) skew(38.57142857142857deg);" title="">
                        <div style="transform: skew(-38.57142857142857deg) rotate(-64.28571428571428deg);">
                          <span></span>
                        </div>
                      </li>
                    </ul>
                    <div class="pan-mask"></div>
                  </div>

                  <ul class="pan-light j-pan-light pan-list animation">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>

                  <div class="btn-wrap">
                    <div class="go-arrow j-arrow" ></div>
                    <!-- <div class="go-arrow j-arrow" deg="-5708.571428571428"
                                        style="transform: rotate(-5708.57deg);"></div> -->

                    <div class="btn-go-bg">
                      <div class="btn-go j-chrome-run" v-on:click="getDraw()">开始</div>
                      <div class="j-animate-assist animate-assist"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="draw-times">
                您还有抽奖机会
                <div class="page-wrap">
                  <div class="page-bg"></div>
                  <div v-show="isLogin" class="page-list j-page-list" style="transform: translateY(0px);">
                     <div>{{lucky}}</div>
                  </div>
                  <div v-show="!isLogin" class="page-num" title="登录后可查看抽奖机会数">?</div>
                </div>
                次
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="j-roulette-dialog roulette-dialog" style="top: 350px; display: none;">
      <div class="dialog-head">
        <span class="head-text j-head-text">没抽奖次数了</span>
        <div class="r-icon-closed j-r-icon-closed"></div>
      </div>
      <div class="dialog-content-wrap j-dialog-content other">
        <div class="dialog-content">
          <span class="dialog-hack other-tip"></span><span class="j-dialog-text other-tip">抽奖次数没了~</span>
          <div class="j-prize-tip dialog-prize"></div>
          <div class="j-prize-name dialog-prize"></div>
        </div>
        <!--  <div class="dialog-remarks">领奖说明：<span class="j-dialog-remarks"></span></div> -->
        <div class="r-btn-closed j-r-btn-closed" v-on:click="close()">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>

  var showDialog = function(title,msg){
    $(".j-roulette-dialog .j-head-text").text(title);
    $(".j-roulette-dialog .j-dialog-text").text(msg);

    $(".j-roulette-dialog").css("display","block");
  }
  var roll = function(e, n, msg, a) {

    var t = $("#wlDiv");
    var h = true;
    var g = 7;
    var l = $(".pan-list");

    var o = "transform",
      r = t.find(".j-chrome-run"),
      s = t.find(".j-arrow"),
      d = 360 / g,
      p = h ? parseFloat(s.attr("deg") || 0) : parseFloat(rouletteArrow.style.rotation),
      u = p % 360,

      m = p - (d * e + u) - 5400;// 计算偏移


    if (r.addClass("going"), h) {
      if (h) {
        t.find(".j-pan-light").removeClass("animation");
        var s = t.find(h ? ".j-arrow" : "#rouletteArrow"),
          j = (24 + Math.floor(~~s.attr("deg") % 360 / 15)) % 24;
        l.eq(j).addClass("light")
      }
      (s.attr("deg", m).css(o, "rotate(" + m + "deg)"), setTimeout(function() {
        r.removeClass("going");
        showDialog((msg=="谢谢参与"? msg : "中奖了"), msg);
      }, 8e3)), s.attr("deg", m), t.find(".j-animate-assist").animate({
        textIndent: m
      }, {
        duration: 8e3,
        complete: function() {
            r.removeClass("going"), t.find(".j-pan-light").addClass("animation");
        },
        step: function(e) {

          var t = Math.abs(Math.floor(e % 360 / (360 / g))),
            n = 24 + Math.floor(e % 360 / 15);

        }
      })
    } else s.animate({
      rotation: m
    }, {
      duration: 8e3,
      complete: function() {
          r.removeClass("going");
      },
      step: function() {
        var e = -parseFloat(s[0].style.rotation),
          n = (e % 360 + 180 / g) % 360,
          i = ~~ (n / d),
          a = t.find("#rouletteShape" + i)[0],
          o = 0 === i ? g - 1 : i - 1,
          r = t.find("#rouletteShape" + o)[0];
        a.fillcolor = "#fff", a.stroked = "true", r.fillcolor = r.getAttribute("data-bg"), r.stroked = "false"
      }
    })
  };
  import {getDrawTimes,getDrawDetails} from 'api/user';
  import {mapGetters} from 'vuex';
  export default{
    data(){
      return {
        luckydipType:3,
        isLogin:''
      }
    },
    created(){
      this.isLogin = sessionStorage.getItem('sid') == null ? false : true;
      this.getPrizeList();
//      this.getDrawTimes();
      this.getWinnerList();
      this.winnerListLoop();
    },
    watch:{
      '$route':function(){
        if(this.$route.path == '/lucky-draw'){
          this.isLogin = sessionStorage.getItem('sid') == null ? false : true;
          this.getPrizeList();
//          this.getDrawTimes();
          this.getWinnerList();
        }
      }
    },
    computed:{
      ...mapGetters([
        'lucky'
      ])
    },
    methods: {
      close(){
        $(".j-roulette-dialog").css("display","none");
      },
      getDraw(){
        if(!this.isLogin){
          this.$Message.warning('请先登录');
          return;
        }
        if($(".j-chrome-run").hasClass("going")){
          return;
        }
        this.draw(dataId=>{
          //this.$store.dispatch('getLucky');
          var index = -1;
          var msg = "";
          var lis = $(".j-pan-chrome").find("li");
          for(var i=0;i<lis.length;i++){
            var a = lis[i];
            if($(a).attr("data-id") == dataId){
              index = parseInt($(a).attr('class').replace("j-prizeId-",""))-1;

              var title = $(a).attr('title');
              if(title == "谢谢参与"){
                msg = title;
              }else{
                msg = "恭喜您，中了"+$(a).attr('title');
              }
              break;
            }
          }

          if(index>=0 && msg!=""){
            roll(index, "hit", msg, 10);
          }

        });
//        setTimeout(() => {
//          this.getDrawTimes();
//        }, 1000)

      },
      // 抽奖
      draw(callback){
        let _params = {
          'luckydip_type': this.luckydipType
        };
        getDrawDetails(_params).then((data) => {
          if(data.result==1){
          if(data.data && data.data.luckydip_goods_id){
            var dataId = data.data.luckydip_goods_id;// 中奖了
            callback(dataId);
            }
          }else{
            if(data.message){
              this.$Message.warning(data.message);
            }
          }
        });
      },
      // 获奖记录
      winnerListLoop(){
        var top =0 ;
        setInterval(function(){
          $.ajax({
            url: '/api/web/personal/luckydipRecords',
            dataType: "json",
            success: function(data) {
              if(data.result==1){
                var list = data.data;
                for(var i=0;i<list.length;i++){
                  var dataItem = list[i];
                  if(dataItem){
                    $(".j-list-wrap").append("<div class=\"winner-item\" style='border-top: 1px dashed #d9d8d8;line-height: 38px;overflow: hidden;'><span class=\"w-name\" style='float: left;overflow: hidden;padding: 0 5%;white-space: nowrap;width: 39%;'>"+dataItem.member_name+"</span><span class=\"w-prize\" style='float: left;overflow: hidden;padding: 0 5%;white-space: nowrap;width: 39%;color: #f34c49;'>"+dataItem.luckydip_goods_name+"</span></div>");
                  }
                }
              }
            }
          });
        },15000);
        setInterval(function(){
          top = top -3.5;
          $(".j-list-wrap").css("top",top +"px");
        },500);
      },
      // 获取奖品列表
      getWinnerList(){
        $.ajax({
          url: '/api/web/personal/luckydipRecords',
          dataType: "json",
          success: function(data) {
            if(data.result==1){
              var list = data.data;
              for(var i=0;i<list.length;i++){
                var dataItem = list[i];
                if(dataItem){
                  $(".j-list-wrap").append("<div class=\"winner-item\" style='border-top: 1px dashed #d9d8d8;line-height: 38px;overflow: hidden;'><span class=\"w-name\" style='float: left;overflow: hidden;padding: 0 5%;white-space: nowrap;width: 39%;'>"+dataItem.member_name+"</span><span class=\"w-prize\" style='float: left;overflow: hidden;padding: 0 5%;white-space: nowrap;width: 39%;color: #f34c49;'>"+dataItem.luckydip_goods_name+"</span></div>");
                }
              }
            }
          }
        });
      },
      // 获取奖品列表
      getPrizeList(){
        $.ajax({
          url: '/api/web/personal/luckydipGoods?luckydip_type='+this.luckydipType + '&t='+ new Date().getTime(),
          dataType: "json",
          success: function(data) {
            if(data.result==1){
              var list = data.data;
              for(var i=0;i< 7 && i<list.length;i++){
                var dataItem = list[i];
                var index = i+1;
                var docItem = $(".j-prizeId-"+index);
                if(docItem){
                  var name = dataItem.name;
                  $(docItem).attr("title", name);
                  $(docItem).attr("data-id",dataItem.luckydip_goods_id);
                  if(name.length>8) name = name.substr(0,8)+'<br />'+name.substr(8);
                  $(docItem).find("span").first().html(name);
                }
              }
            }else{
              showDialog("抽奖错误", "获取奖品列表失败.");
            }
          }
        });
      },
      // 获取抽奖次数
      getDrawTimes(){
      if(this.isLogin){
        let _params = {
          'luckydip_type': this.luckydipType
        };
        getDrawTimes(_params).then((json) => {
            var times = 0;// 请求后台获取
            if(json.data && json.data.times){
              times = parseInt(json.data.times);
            }
            $(".draw-times").find(".j-page-list").html("<div>"+times+"</div>");
        });
      }
    }

    }
  }
</script>
<style lang="less" scoped>

  .d-w190, .d-w213, .d-w215, .d-w240, .d-w252, .d-w323, .d-w324, .d-w390, .d-w490, .d-w546, .d-w590, .d-w731, .d-w764, .d-w790, .d-w990, .w190, .w213, .w215, .w240, .w252, .w323, .w324, .w390, .w490, .w546, .w590, .w731, .w764, .w790, .w990 {
    overflow-wrap: break-word;
    overflow-x: hidden;
    word-break: break-all;
  }

  .m, .mb, .mc, .mt, .p-detail, .p-img, .p-market, .p-name, .p-price, .sm, .smb, .smc, .smt {
    overflow: hidden;
  }



  .d-layout {
    clear: both;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    width: 990px;
  }

  .d-w990 {
    width: 990px;
  }


  /*********copy************************************************************/

  .single-place {
    bottom: 0;
    left: 0;
    position: absolute;
  }
  .userdefined-153704 .j-module {
    overflow: hidden;
  }
  .hidden {
    display: none;
  }
  .rvml {
    display: block;
  }
  .roulette-174865 mc {
    position: relative;
  }
  .roulette-174865 .roulette-container {
    background-color: #faebc0;
    height: 624px;
    margin: auto;
    position: relative;
    width: 999px;
  }
  .roulette-174865 .roulette-ie {
    height: 348px;
    left: 496px;
    padding: 38px;
    position: absolute;
    top: 109px;
    width: 339px;
  }
  .roulette-174865 .roulette-ie .pan-bg {
    background: rgba(0, 0, 0, 0) url("images/564ac354Nddf6b8ce.png") no-repeat scroll center center;
    height: 424px;
    left: 0;
    position: absolute;
    top: 0;
    width: 415px;
  }
  .roulette-174865 .roulette-ie .pan-content {
    position: relative;
  }

  .roulette-174865 .roulette-ie .prize-name {
    color: #d1a58b;
    font-size: 14px;
    height: 110px;
    line-height: 38px;
    position: absolute;
    text-align: center;
    white-space: nowrap;
    width: 110px;
    z-index: 11;
  }
  .roulette-174865 .roulette-ie .prize-name.current {
    color: #d1a58b;
  }
  .roulette-174865 .roulette-ie .prize-pic {
    height: 100px;
    position: absolute;
    width: 100px;
  }
  .roulette-174865 .roulette-ie .prize-pic img {
    display: block;
    height: 60px;
    margin: 40px 25px 0;
    width: 60px;
  }
  .roulette-174865 .roulette-ie .prize-pic.img4 img {
    height: 50px;
    margin: 46px 30px 0;
    width: 50px;
  }
  .roulette-174865 .roulette-ie .prize-pic.img7 img {
    height: 40px;
    margin: 50px 35px 0;
    width: 40px;
  }
  .roulette-174865 .roulette-ie .go {
    background: rgba(0, 0, 0, 0) url("images/564c0da1Ne20a2d07.png") no-repeat scroll center center;
    cursor: pointer;
    height: 90px;
    left: 163px;
    position: absolute;
    top: 163px;
    width: 89px;
  }
  .roulette-174865 .roulette-ie .go.going {
    background-image: url("images/564c0d9cNcd86a3de.png");
    cursor: default;
  }
  .roulette-174865 .roulette-ie .arrow {
    background: rgba(0, 0, 0, 0) url("images/564ac3faN6cf8eddc.png") no-repeat scroll center center;
    height: 140px;
    left: 137.5px;
    position: absolute;
    top: 137.5px;
    width: 140px;
  }
  .roulette-174865 .roulette-ie .arrow-ie {
    height: 140px;
    left: 100px;
    position: absolute;
    top: 100px;
    width: 140px;
  }
  .roulette-174865 .roulette-ie .line-ie {
    left: 100px;
    position: absolute;
    top: 100px;
  }
  .roulette-174865 .winner-area {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 8px 0 0 #ebd1a5;
    font-size: 12px;
    height: 456px;
    left: 60px;
    padding: 45px 15px 15px;
    position: absolute;
    top: 52px;
    width: 282px;
  }
  .roulette-174865 .winner-list {
    height: 360px;
    margin: 0 5px;
    overflow: hidden;
    position: relative;
  }
  .roulette-174865 .winner-list::before {
    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%) repeat scroll 0 0;
    content: "";
    height: 40px;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }
  .roulette-174865 .list-wrap {
    display: none;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .roulette-174865 .winner-title {
    height: 40px;
    line-height: 40px;
    position: relative;
    text-align: center;
  }
  .roulette-174865 .title-bg {
    border-top: 2px solid #f34c49;
    left: 0;
    position: absolute;
    top: 19px;
    width: 100%;
  }
  .roulette-174865 .title-content {
    background-color: #fff;
    color: #f34c49;
    display: inline-block;
    font-size: 24px;
    padding: 0 10px;
    position: relative;
  }
  .roulette-174865 .winner-title2 {
    line-height: 36px;
    margin: 10px 0;
    overflow: hidden;
  }
  .roulette-174865 .winner-area span {
    float: left;
    overflow: hidden;
    padding: 0 5%;
    white-space: nowrap;
    width: 39%;
  }
  .roulette-174865 .winner-item {
    border-top: 1px dashed #d9d8d8;
    line-height: 38px;
    overflow: hidden;
  }
  .roulette-174865 .no-border {
    border: 0 none;
  }
  .roulette-174865 .w-th {
    color: #9d4e21;
    font-size: 16px;
  }
  .roulette-174865 .w-name {
    color: #928977;
  }
  .roulette-174865 .w-prize {
    color: #f34c49;
  }
  .roulette-174865 .no-winner {
    color: #666;
    font-size: 14px;
    line-height: 300px;
    text-align: center;
  }
  .ie67mask {
  }
  .roulette-174865 .draw-times {
    color: #9d4e21;
    font-size: 20px;
    height: 36px;
    left: 600px;
    position: absolute;
    top: 550px;
  }
  .roulette-174865 .draw-times .page-wrap {
    background-color: #ddd;
    color: #f34c49;
    display: inline-block;
    font-size: 24px;
    height: 30px;
    line-height: 30px;
    margin: 0 5px;
    min-width: 32px;
    overflow: hidden;
    position: relative;
    text-align: center;
    vertical-align: middle;
  }
  .roulette-174865 .draw-times .page-num {
    position: relative;
  }
  .roulette-174865 .draw-times .page-bg {
    background-color: #fff;
    border-top: 1px dashed #f0d5c5;
    height: 50%;
    position: absolute;
    top: 50%;
    width: 100%;
  }
  .roulette-174865 .draw-times .page-list {
    height: 100%;
    position: relative;
    transition: transform 0.6s ease-out 0s;
  }
  .roulette-174865 .bg-widget {
    background: rgba(0, 0, 0, 0) url("images/56654bf7N5278a331.png") no-repeat scroll 0 0;
    position: absolute;
    z-index: 1;
  }
  .roulette-174865 .bg-widget.animation {
    transition: transform 0.5s ease-in 0s;
  }
  .roulette-174865 .bg-1 {
    background: rgba(0, 0, 0, 0) url("images/56612ce3Na656bb98.png") no-repeat scroll center center;
    height: 96px;
    left: 0;
    position: absolute;
    top: 0;
    width: 999px;
  }
  .roulette-174865 .bg-2 {
    background-position: 0 0;
    height: 215px;
    right: 0;
    top: 0;
    width: 663px;
  }
  .roulette-174865 .bg-3 {
    background-position: -99px -455px;
    height: 100px;
    right: 508px;
    top: 455px;
    width: 55px;
  }
  .roulette-174865 .bg-4 {
    background-position: -552px -379px;
    height: 180px;
    right: 0;
    top: 376px;
    width: 110px;
  }
  .roulette-174865 .btn-wrap {
    cursor: pointer;
    height: 84px;
    left: 50%;
    margin-left: -42px;
    margin-top: -42px;
    position: absolute;
    top: 50%;
    width: 84px;
  }
  .roulette-174865 .btn-go-bg {
    border: 6px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.56);
    height: 72px;
    position: relative;
    width: 72px;
  }
  .roulette-174865 .btn-go-bg::before {
    background-color: #d71c1c;
    border-radius: 50%;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .roulette-174865 .btn-go {
    background-color: #f34c49;
    border-radius: 50%;
    box-shadow: 1px 2px 2px rgba(255, 253, 242, 0.4) inset;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    height: 66px;
    line-height: 70px;
    margin: 1px 0 0 1px;
    position: relative;
    text-align: center;
    text-shadow: 0 2px 2px #d71c1c;
    width: 68px;
  }
  .roulette-174865 .btn-go:hover {
    background-color: #f95956;
  }
  .roulette-174865 .btn-go.going {
    cursor: default;
    height: 69px;
    width: 69px;
  }
  .roulette-174865 .go-arrow {
    height: 100%;
    left: 50%;
    margin-left: -42px;
    margin-top: -42px;
    position: absolute;
    top: 50%;
    transform: rotate(0deg);
    transition: transform 8s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    width: 100%;
  }
  .roulette-174865 .go-arrow::before {
    background: rgba(0, 0, 0, 0) url("images/5667d6dcN92b5a9c9.png") no-repeat scroll 0 0;
    content: "";
    height: 52px;
    left: 17px;
    position: absolute;
    top: -26px;
    width: 50px;
  }
  .roulette-dialog {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
    display: none;
    left: 50%;
    margin-left: -160px;
    margin-top: -100px;
    min-height: 193px;
    position: absolute;
    text-align: center;
    width: 320px;
    z-index: 10001;
  }
  .roulette-dialog .dialog-head {
    background-color: #f34c49;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    position: relative;
  }
  .roulette-dialog .r-icon-closed {
    background: rgba(0, 0, 0, 0) url("images/5649358dN62bade24.png") no-repeat scroll center center;
    height: 20px;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 20px;
  }
  .roulette-dialog .r-icon-closed:hover {
    color: #fff;
    cursor: pointer;
  }
  .roulette-dialog .dialog-content-wrap {
    padding: 20px;
  }
  .roulette-dialog .dialog-prize {
    color: #f34c49;
    white-space: nowrap;
  }
  .roulette-dialog .dialog-content {
    color: #666;
    font-size: 14px;
    height: 42px;
    line-height: 1.5;
    margin-bottom: 15px;
    overflow: hidden;
  }
  .roulette-dialog .dialog-content span {
    display: inline-block;
    vertical-align: middle;
  }
  .roulette-dialog .dialog-content-wrap.hit .other-tip, .dialog-content-wrap.hit .r-btn-closed, .dialog-content-wrap.other .dialog-prize, .dialog-content-wrap.other .dialog-remarks {
    display: none;
  }
  .roulette-dialog .dialog-hack {
    height: 100%;
  }
  .roulette-dialog .r-btn-closed {
    background-color: #d71c1c;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    margin: auto;
    width: 80px;
  }
  .roulette-dialog .r-btn-closed:hover {
    background-color: #f34c49;
    cursor: pointer;
  }
  .roulette-dialog .dialog-remarks {
    color: #666;
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
  }
  .roulette-dialog .dialog-remarks span {
    color: #999;
  }
  .roulette-input-dialog {
    background: rgba(0, 0, 0, 0) url("images/5667efdcN9a74ae20.png") no-repeat scroll 0 0;
    display: none;
    height: 425px;
    left: 50%;
    margin-left: -335px;
    margin-top: -213px;
    position: absolute;
    top: 50%;
    width: 669px;
    z-index: 101;
  }
  .roulette-input-dialog .head-text {
    color: #fc1621;
    font-size: 31px;
    font-weight: bold;
    padding: 50px 0 10px;
    text-align: center;
  }
  .roulette-input-dialog .head-desc {
    color: #afafaf;
    font-size: 18px;
    padding: 16px 0 0 90px;
  }
  .roulette-input-dialog .prize-name {
    color: #fc1621;
    padding: 0 5px;
  }
  .roulette-input-dialog .dialog-form {
    font-size: 14px;
    padding: 15px 0 0 90px;
  }
  .roulette-input-dialog .user-address {
    margin-top: 40px;
  }
  .roulette-input-dialog .dialog-form div {
    margin-bottom: 10px;
    overflow: hidden;
  }
  .roulette-input-dialog .dialog-form span {
    color: #d70916;
    display: inline-block;
    font-size: 18px;
    padding: 4px 5px 0 0;
    vertical-align: middle;
  }
  .roulette-input-dialog .dialog-form label {
    color: #7f7f7f;
    float: left;
    margin-right: 15px;
    text-align: right;
    width: 75px;
  }
  .roulette-input-dialog .dialog-form input {
    border: 1px solid #cdcdcd;
    color: #1e1e1e;
    float: left;
    font-family: "Microsoft YaHei";
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    padding: 0 5px;
    width: 300px;
  }
  .roulette-input-dialog .error input {
    border-color: #f04e4e !important;
  }
  .roulette-input-dialog .dialog-form .error-tip {
    color: #fc1621;
    display: none;
    float: left;
    font-size: 12px;
    padding-left: 10px;
  }
  .roulette-input-dialog .error .error-tip {
    color: #fc1621;
    display: inline;
    font-size: 12px;
    padding: 7px 0 0 10px;
  }
  .roulette-input-dialog .dialog-form textarea {
    border: 1px solid #cdcdcd;
    color: #1e1e1e;
    float: left;
    height: 56px;
    line-height: 28px;
    padding: 0 5px;
    resize: none;
    width: 308px;
  }
  .roulette-input-dialog .btn-area {
    bottom: 22px;
    position: absolute;
    width: 100%;
  }
  .roulette-input-dialog .btn-area button {
    background-color: rgba(254, 226, 51, 0.9);
    border: 0 none;
    border-radius: 20px;
    color: #d70916;
    cursor: pointer;
    display: block;
    font-family: "Microsoft YaHei","Arial";
    font-size: 22px;
    line-height: 40px;
    margin: auto;
    text-align: center;
    width: 140px;
  }
  .roulette-input-dialog .btn-area button:hover {
    background-color: rgba(254, 226, 51, 1);
  }
  .roulette-input-dialog .ui-area-wrap {
    left: 180px;
    position: absolute;
    top: 207px;
  }
  .roulette-input-dialog .ui-area-wrap .ui-area-text-wrap {
    color: #1e1e1e;
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    width: 286px;
  }
  .roulette-input-dialog .ui-area-wrap .ui-area-content-wrap {
    top: 28px;
  }
  .roulette-input-dialog .ui-area-wrap a {
    color: #005aa0;
    font-size: 12px;
    text-decoration: none;
  }
  .roulette-input-dialog .ui-area-wrap em {
    font-style: normal;
  }
  .roulette-input-dialog .submited-tip {
    text-align: center;
  }
  .roulette-input-dialog .submited-tip .main-tip {
    color: #0d0d0d;
    font-size: 26px;
    line-height: 40px;
    padding-top: 115px;
  }
  .roulette-input-dialog .submited-tip .sub-tip {
    color: #b5b5b5;
    font-size: 14px;
    font-weight: bold;
    padding-top: 22px;
  }
  .roulette-174865 .cn-wrapper * {
    box-sizing: border-box!important;
    list-style: outside none none;
    margin: 0;
    padding: 0;
    position: relative;
  }
  .roulette-174865 .csstransforms .cn-wrapper {
    border-radius: 50%;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .roulette-174865 .csstransforms .cn-wrapper.r-double li {
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    height: 50%;
    left: 0;
    top: 0;
    transform-origin: 50% 100% 0;
  }
  .roulette-174865 .csstransforms .cn-wrapper.r-double li:nth-child(2) {
    transform: rotate(180deg);
  }
  .roulette-174865 .csstransforms .cn-wrapper.r-double li div {
    height: 100%;
    padding-top: 10px;
    position: static;
    text-align: center;
    text-decoration: none;
    width: 100%;
  }
  .roulette-174865 .csstransforms .cn-wrapper li {
    height: 100%;
    left: -50%;
    overflow: hidden;
    position: absolute;
    top: -50%;
    transform-origin: 100% 100% 0;
    width: 100%;
  }
  .roulette-174865 .csstransforms .cn-wrapper li div {
    height: 150%;
    left: 10%;
    position: absolute;
    text-align: center;
    text-decoration: none;
    top: 10%;
    width: 150%;
  }
  .roulette-174865 .csstransforms .cn-wrapper li img {
    display: block;
    height: 50px;
    margin: 17px auto 0;
    width: 50px;
  }
  .roulette-174865 .csstransforms .item-wrap3 li div {
    padding-top: 147px;
    top: 12%;
  }
  .roulette-174865 .csstransforms .item-wrap4 li div {
    padding-top: 168px;
  }
  .roulette-174865 .csstransforms .item-wrap5 li div {
    left: 11%;
    padding-top: 174px;
    top: 11%;
  }
  .roulette-174865 .csstransforms .item-wrap6 li div {
    padding-top: 184px;
    top: 12%;
  }
  .roulette-174865 .csstransforms .item-wrap7 li div {
    padding-top: 189px;
    top: 13%;
  }
  .roulette-174865 .csstransforms .item-wrap7 li img {
    height: 40px;
    width: 40px;
  }
  .roulette-174865 .csstransforms .item-wrap8 li div {
    left: 9%;
    padding-top: 195px;
    top: 14%;
  }
  .roulette-174865 .csstransforms .item-wrap8 li img {
    height: 40px;
    width: 40px;
  }
  .roulette-174865 .csstransforms .item-wrap9 li div {
    left: 8%;
    padding-top: 205px;
    top: 14%;
  }
  .roulette-174865 .csstransforms .item-wrap9 li img {
    height: 40px;
    width: 40px;
  }
  .roulette-174865 .csstransforms .cn-wrapper li span {
    color: #ab6842;
    font-size: 13px;
  }
  .roulette-174865 .csstransforms .cn-wrapper li:nth-child(2n+1) div {
    background-color: #fff1de;
  }
  .roulette-174865 .csstransforms .cn-wrapper li:nth-child(2n) div {
    background-color: #fff5f5;
  }
  .roulette-174865 .csstransforms .bg3 li:nth-child(3n) div {
    background-color: #fff1de;
  }
  .roulette-174865 .csstransforms .bg3 li:nth-child(3n+1) div {
    background-color: #fff5f5;
  }
  .roulette-174865 .csstransforms .bg3 li:nth-child(3n+2) div {
    background-color: #fcfeee;
  }
  .roulette-174865 .csstransforms .cn-wrapper.r-double li.current::after {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    border-color: -moz-use-text-color -moz-use-text-color #f34c49;
    border-image: none;
    border-style: none none solid;
    border-width: medium medium 2px;
  }
  .roulette-174865 .csstransforms .cn-wrapper li.current::after {
    border: 2px solid #f3e5e5;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  .roulette-174865 .csstransforms .cn-wrapper li.current div {
    background-color: #fff;
  }
  .roulette-174865 .roulette-chrome {
    background-color: #9d4a21;
    border-radius: 50%;
    box-shadow: 0 8px 0 0 #ebd1a5;
    height: 415px;
    left: 496px;
    overflow: hidden;
    position: absolute;
    top: 109px;
    width: 415px;
  }
  .roulette-174865 .roulette-chrome .pan-content {
    box-sizing: content-box;
    height: 100%;
    position: relative;
    width: 100%;
  }
  .roulette-174865 .roulette-chrome .pan-bg {
    background-color: #f34c49;
    border: 3px solid #fc6d68;
    border-radius: 50%;
    height: 341px;
    margin: 8px;
    padding: 26px;
    position: relative;
    width: 341px;
  }
  .roulette-174865 .roulette-chrome .pan-mask {
    border: 35px solid rgba(102, 102, 102, 0.1);
    border-radius: 50%;
    height: 271px;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 271px;
  }
  .roulette-174865 .pan-list {
    left: 50%;
    margin-left: -10px;
    position: absolute;
    top: 0;
  }
  .roulette-174865 .pan-list li {
    height: 196.5px;
    left: 5px;
    position: absolute;
    top: 0;
    transform-origin: 50% 100% 0;
    width: 10px;
  }
  .roulette-174865 .pan-list li::before {
    background-color: #fee8bb;
    border-radius: 50%;
    box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    content: "";
    height: 12px;
    left: 0;
    position: absolute;
    top: 6px;
    width: 12px;
    z-index: 3;
  }
  .roulette-174865 .pan-list li.light::before {
    background-color: #fff;
    box-shadow: 0 4px 3px #d71c1c, 0 0 12px #fff, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
  }
  .roulette-174865 .pan-list li:nth-child(2) {
    transform: rotate(15deg);
  }
  .roulette-174865 .pan-list li:nth-child(2)::before {
    transform: rotate(345deg);
  }
  .roulette-174865 .pan-list li:nth-child(3) {
    transform: rotate(30deg);
  }
  .roulette-174865 .pan-list li:nth-child(3)::before {
    transform: rotate(330deg);
  }
  .roulette-174865 .pan-list li:nth-child(4) {
    transform: rotate(45deg);
  }
  .roulette-174865 .pan-list li:nth-child(4)::before {
    transform: rotate(315deg);
  }
  .roulette-174865 .pan-list li:nth-child(5) {
    transform: rotate(60deg);
  }
  .roulette-174865 .pan-list li:nth-child(5)::before {
    transform: rotate(300deg);
  }
  .roulette-174865 .pan-list li:nth-child(6) {
    transform: rotate(75deg);
  }
  .roulette-174865 .pan-list li:nth-child(6)::before {
    transform: rotate(285deg);
  }
  .roulette-174865 .pan-list li:nth-child(7) {
    transform: rotate(90deg);
  }
  .roulette-174865 .pan-list li:nth-child(7)::before {
    transform: rotate(270deg);
  }
  .roulette-174865 .pan-list li:nth-child(8) {
    transform: rotate(105deg);
  }
  .roulette-174865 .pan-list li:nth-child(8)::before {
    transform: rotate(255deg);
  }
  .roulette-174865 .pan-list li:nth-child(9) {
    transform: rotate(120deg);
  }
  .roulette-174865 .pan-list li:nth-child(9)::before {
    transform: rotate(240deg);
  }
  .roulette-174865 .pan-list li:nth-child(10) {
    transform: rotate(135deg);
  }
  .roulette-174865 .pan-list li:nth-child(10)::before {
    transform: rotate(225deg);
  }
  .roulette-174865 .pan-list li:nth-child(11) {
    transform: rotate(150deg);
  }
  .roulette-174865 .pan-list li:nth-child(11)::before {
    transform: rotate(210deg);
  }
  .roulette-174865 .pan-list li:nth-child(12) {
    transform: rotate(165deg);
  }
  .roulette-174865 .pan-list li:nth-child(12)::before {
    transform: rotate(195deg);
  }
  .roulette-174865 .pan-list li:nth-child(13) {
    transform: rotate(180deg);
  }
  .roulette-174865 .pan-list li:nth-child(13)::before {
    transform: rotate(180deg);
  }
  .roulette-174865 .pan-list li:nth-child(14) {
    transform: rotate(195deg);
  }
  .roulette-174865 .pan-list li:nth-child(14)::before {
    transform: rotate(165deg);
  }
  .roulette-174865 .pan-list li:nth-child(15) {
    transform: rotate(210deg);
  }
  .roulette-174865 .pan-list li:nth-child(15)::before {
    transform: rotate(150deg);
  }
  .roulette-174865 .pan-list li:nth-child(16) {
    transform: rotate(225deg);
  }
  .roulette-174865 .pan-list li:nth-child(16)::before {
    transform: rotate(135deg);
  }
  .roulette-174865 .pan-list li:nth-child(17) {
    transform: rotate(240deg);
  }
  .roulette-174865 .pan-list li:nth-child(17)::before {
    transform: rotate(120deg);
  }
  .roulette-174865 .pan-list li:nth-child(18) {
    transform: rotate(255deg);
  }
  .roulette-174865 .pan-list li:nth-child(18)::before {
    transform: rotate(105deg);
  }
  .roulette-174865 .pan-list li:nth-child(19) {
    transform: rotate(270deg);
  }
  .roulette-174865 .pan-list li:nth-child(19)::before {
    transform: rotate(90deg);
  }
  .roulette-174865 .pan-list li:nth-child(20) {
    transform: rotate(285deg);
  }
  .roulette-174865 .pan-list li:nth-child(20)::before {
    transform: rotate(75deg);
  }
  .roulette-174865 .pan-list li:nth-child(21) {
    transform: rotate(300deg);
  }
  .roulette-174865 .pan-list li:nth-child(21)::before {
    transform: rotate(60deg);
  }
  .roulette-174865 .pan-list li:nth-child(22) {
    transform: rotate(315deg);
  }
  .roulette-174865 .pan-list li:nth-child(22)::before {
    transform: rotate(45deg);
  }
  .roulette-174865 .pan-list li:nth-child(23) {
    transform: rotate(330deg);
  }
  .roulette-174865 .pan-list li:nth-child(23)::before {
    transform: rotate(30deg);
  }
  .roulette-174865 .pan-list li:nth-child(24) {
    transform: rotate(345deg);
  }
  .roulette-174865 .pan-list li:nth-child(24)::before {
    transform: rotate(15deg);
  }
  .roulette-174865 .animate-assist {
    display: none;
  }
  .roulette-174865 .pan-list.animation li:nth-child(2n)::before {
    animation: 1s linear 0.5s normal none infinite running lightShining;
  }
  .roulette-174865 .pan-list.animation li:nth-child(2n+1)::before {
    animation: 1s ease 0s normal none infinite running lightShining;
  }
  @keyframes lightShining {
    0% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    49% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    50% {
      background-color: #fff;
      box-shadow: 0 4px 3px #d71c1c, 0 0 12px #fff, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    99% {
      background-color: #fff;
      box-shadow: 0 4px 3px #d71c1c, 0 0 12px #fff, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    100% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
  }
  @keyframes lightShining {
    0% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    49% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    50% {
      background-color: #fff;
      box-shadow: 0 4px 3px #d71c1c, 0 0 12px #fff, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    99% {
      background-color: #fff;
      box-shadow: 0 4px 3px #d71c1c, 0 0 12px #fff, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
    100% {
      background-color: #fee8bb;
      box-shadow: 0 4px 3px #d71c1c, 0 0 6px #fef64a, 0 0 2px #fef64a inset;
    }
  }
  embed {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// lucky-draw.vue?55e68a06